export default __webpack_public_path__ + "static/media/iconeCertificadores.15e38789.png";